import React from 'react';

import { observer } from 'mobx-react';
import { Option, OptionWrapper } from 'libs/forms/styles';

export const CountryOption = observer(
  ({ app, highlighted, onClick, onMouseOver, scrollRef }) => {
    return (
      <OptionWrapper
        ref={scrollRef}
        highlighted={highlighted}
        onMouseOver={onMouseOver}
        onClick={onClick}
      >
        <Option highlighted={highlighted} disabled={app.disabled}>
          {app.label}
        </Option>
      </OptionWrapper>
    );
  },
);
